import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {marketRegister} from "../../services/marketRegister";
import {demoRegister} from "../../services/demoRegister";
import ReactGA from "react-ga";
import {campaignRegister} from "../../services/campaignRegister";
import Countdown from "../../components/countdown/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class SignupConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            channels: null,
            currency: "",
            budget: null,
            plan: {},
            duration: null,
            vat: 0,
            lockin: null,
            landingpage: null,
            no_pay: false,
            company_name: "",
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();

        //GOOGLE ANALYTICS
        if(window.location.href.indexOf("devadbop.com") === -1){
            ReactGA.pageview('/signup-confirmation');
        }
    }


    _updateData() {

        //TEMP
        let cart = cartRegister.get();

        let campaign = campaignRegister.get();
        if (campaign) {
            this.setState({
                channels: campaign.channels,
                campaign_fee: campaign.campaign_cost === 0 ? null : campaign.campaign_cost,
                vat: campaign.vat_percentage / 100,
                duration: campaign.duration,
                currency: campaign.currency,
                service_fee: campaign.service_fee === 0 ? null : campaign.service_fee,
                discount: campaign.discount > 0?campaign.discount:null,
                excess_credits: campaign.excess_credits > 0?campaign.excess_credits:null,
                id: campaign.campaign_id,
                lockin: campaign.lockin?campaign.lockin:0,
                plan: cart.plan,
                no_pay: campaign.no_pay ? campaign.no_pay : false
            }, () => {
                campaignRegister.remove();
                cartRegister.remove();
                imagesRegister.remove();
                quotesRegister.remove();
            });
        } else {
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
        }
    }

    _myAccount() {
        try {
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/campaigns/running");
        } catch (error) {
        }
    }

    _myInvites() {
        try {
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/invite");
        } catch (error) {}
    }

    _renderPartialBudget() {
        if (this.state.channels) {
            let budget = 0;

            if(!this.state.campaign_fee){
                for (let key in this.state.channels) {
                    budget = budget + this.state.channels[key];
                }

                if (this.state.service_fee) {
                    budget = budget + this.state.service_fee;
                }
            }else{
                budget = budget + this.state.campaign_fee;
            }

            if (this.state.discount) {
                budget = budget - +this.state.discount;
            }

            if (this.state.excess_credits) {
                budget = budget - +this.state.excess_credits;
            }

            return budget;

        } else {
            return ("...");
        }
    }

    _renderDiscount(){
        let discount = 0;
        if(this.state.discount){
            discount = discount + +this.state.discount
        }
        if(this.state.excess_credits){
            discount = discount + +this.state.excess_credits
        }
        return discount;
    }

    _renderChannel(channel) {
        let item = channel;
        if (item === "fb") {
            item = "facebook"
        }
        if(item === "facebook"){
            return "Facebook social"
        }else if(item === "instagram"){
            return "Instagram social"
        }else if(item === "google"){
            return "Google search"
        }else if(item === "bing"){
            return "Bing search"
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return (0)
        }
    }

    _renderText(item) {
        return langRegister.get("signup-confirmation", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>
                {
                    this.state.channels && this.state.duration &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <span className={Styles.titleBold}>{this._renderText("item_1")}</span>&nbsp;{this._renderText("item_2")}&nbsp;
                            {
                                !this.state.no_pay &&
                                <span className={Styles.titleBoldGreen}>{this._renderText("item_3")}</span>
                            }
                            {
                                this.state.no_pay &&
                                <span className={Styles.titleBoldRed}>{this._renderText("item_27")}</span>
                            }
                        </div>
                        <div className={Styles.campaignId}>
                            {this._renderText("item_4")} <span
                            className={Styles.campaignIdNumber}>#{this.state.id}</span>
                        </div>
                        <div className={Styles.divider}/>
                        <div onClick={() => this._myAccount()} className={cx(Styles.button, Styles.buttonBlack)}>
                            {this._renderText("item_11")}
                        </div>
                        {
                            false &&
                            <div onClick={() => this._myInvites()} className={Styles.button}>
                                {this._renderText("item_12")}
                            </div>
                        }
                        <div className={Styles.divider}/>
                        <div className={Styles.contentContainerItem}>
                            <div className={Styles.contentContainerItemUpper}>
                                <div className={Styles.contentContainerItemUpperLeft}>
                                    {this._renderText("item_19")}&nbsp;{this.state.lockin > 1 && this.state.campaign_fee &&<span>X&nbsp;{this.state.lockin}</span>}
                                </div>
                                <div className={Styles.contentContainerItemUpperRight}>
                                    {this.state.duration}&nbsp;{this._renderText("item_20")}
                                </div>
                            </div>
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.contentContainer}>
                            {
                                Object.keys(this.state.channels).map((key, i) => {
                                    return (
                                        <div key={i} className={Styles.contentContainerItem}>
                                            <div className={Styles.contentContainerItemUpper}>
                                                <div className={Styles.contentContainerItemUpperLeft}>
                                                    {this._renderChannel(key).toUpperCase()}&nbsp;{this.state.lockin > 1 && this.state.campaign_fee &&<span>X&nbsp;{this.state.lockin}</span>}
                                                </div>
                                                <div className={Styles.contentContainerItemUpperRight}>
                                                    {this._renderNumbers(Math.round(this.state.channels[key]))}&nbsp;{this.state.currency.toUpperCase()}
                                                </div>
                                            </div>
                                            <div className={Styles.contentContainerItemLower}>
                                                <div className={Styles.contentContainerItemLowerLeft}>
                                                    {Math.floor(this.state.channels[key] / this.state.duration)}&nbsp;{this.state.currency.toLowerCase()}&nbsp;/&nbsp;{this._renderText("item_21")}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                (this.state.service_fee > 0) &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div className={Styles.contentContainerItemUpperLeft}>
                                            {this._renderText("item_15").toUpperCase()}
                                        </div>
                                        {
                                            this.state.service_fee &&
                                            <div className={Styles.contentContainerItemUpperRight}>
                                                {this._renderNumbers(Math.round(this.state.service_fee))}&nbsp;{this.state.currency.toUpperCase()}
                                            </div>
                                        }
                                    </div>
                                    <div className={Styles.contentContainerItemLower}>
                                        <div className={Styles.contentContainerItemLowerLeftService}>
                                            {
                                                this.state.lockin > 1 &&
                                                <span>{this._renderText("item_24")}&nbsp;{this.state.lockin}</span>
                                            }
                                            {
                                                this.state.lockin < 2 &&
                                                <span>{this._renderText("item_26")}</span>
                                            }
                                        </div>
                                        {
                                            false &&
                                            <div className={Styles.contentContainerItemLowerRightService}>
                                                {
                                                    this.state.discount > 0 &&
                                                    <span>-{this._renderNumbers(Math.round(this.state.discount))} {this.state.currency.toUpperCase()}</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                (this.state.campaign_fee > 0 && this.state.discount > 0) && false &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div className={cx(Styles.contentContainerItemUpperLeft, Styles.contentContainerItemUpperRightGreen)}>
                                            {this._renderText("item_25").toUpperCase()}
                                        </div>
                                        <div className={cx(Styles.contentContainerItemUpperRight, Styles.contentContainerItemUpperRightGreen)}>
                                            <span>-{this._renderNumbers(Math.round(this.state.discount))} {this.state.currency.toUpperCase()}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.excess_credits || this.state.discount) &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div
                                            className={cx(Styles.contentContainerItemUpperLeft, Styles.contentContainerItemUpperRightGreen)}>
                                            {this._renderText("item_25").toUpperCase()}
                                        </div>
                                        <div
                                            className={cx(Styles.contentContainerItemUpperRight, Styles.contentContainerItemUpperRightGreen)}>
                                            <span>-</span>{this._renderNumbers(Math.round(this._renderDiscount()))}{" "}{this.state.currency.toUpperCase()}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.vatContainer}>
                            <div className={Styles.vatContainerLeft}>
                                {this._renderText("item_17")}&nbsp;({+this.state.vat * 100}%)
                            </div>
                            <div className={Styles.vatContainerRight}>
                                {this._renderNumbers(this._renderPartialBudget() * +this.state.vat)}&nbsp;{this.state.currency.toUpperCase()}
                            </div>
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.totalContainer}>
                            <div className={Styles.totalContainerLeft}>
                                {this._renderText("item_18")}
                            </div>
                            <div className={Styles.totalContainerRight}>
                                {this._renderNumbers(this._renderPartialBudget() * (+this.state.vat + 1))}&nbsp;{this.state.currency.toUpperCase()}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

/*
  <div className={Styles.campaignDate}>
                            <Countdown date={30}/>
                        </div>

                            <span>{this._renderText("item_5")}</span><span className={Styles.campaignDateBold}>&nbsp;29{this._renderText("item_6")}&nbsp;:&nbsp;24{this._renderText("item_7")}&nbsp;:&nbsp;59{this._renderText("item_8")}&nbsp;:&nbsp;59{this._renderText("item_9")}</span>&nbsp;{this._renderText("item_10")}

 */

export default SignupConfirmation;


// WEBPACK FOOTER //
// ./src/pages/signup-confirmation/component.js